<template lang="pug">
  div
    b-row
      .col-xl-10
        panel(:title='$t("ui.bank_account")')
          b-card
            b-form(novalidate @submit.prevent="submit" :disabled="!submission.success")
              b-row.flex
                .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                  label {{ $t("ui.bank_name") }}
                  DebounceInput(
                    type="text"
                    ref="bank_name"
                    :dirty="$v.bank_name.$dirty"
                    :error="$v.bank_name.$error"
                    :placeholder='$t("ui.bank_name")'
                    v-model.trim.lazy="$v.bank_name.$model"
                    :maxLength="$v.bank_name.$params.maxLength.max"
                    :disabled="loading"
                  )
                  ValidateResult(:value="$v.bank_name" :name="$t('ui.bank_name')")
              b-row.flex
                .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-2
                  label {{ $t("ui.bank_acc_no") }}
                  DebounceInput(
                    type="text"
                    ref="bank_acc_no"
                    :dirty="$v.bank_acc_no.$dirty"
                    :error="$v.bank_acc_no.$error"
                    :placeholder='$t("ui.bank_acc_no")'
                    v-model.trim.lazy="$v.bank_acc_no.$model"
                    :maxLength="$v.bank_acc_no.$params.maxLength.max"
                    :disabled="loading"
                  )
                  ValidateResult(:value="$v.bank_acc_no" :name="$t('ui.bank_acc_no')")
              b-row.flex
                .col-sm-12.col-md-6.col-lg-6.col-xl-6.mb-4
                  label {{ $t("ui.bank_acc_holder") }}
                  DebounceInput(
                    type="text"
                    ref="bank_acc_holder"
                    :dirty="$v.bank_acc_holder.$dirty"
                    :error="$v.bank_acc_holder.$error"
                    :placeholder='$t("ui.bank_acc_holder")'
                    v-model.trim.lazy="$v.bank_acc_holder.$model"
                    :maxLength="$v.bank_acc_holder.$params.maxLength.max"
                    :disabled="loading"
                  )
                  ValidateResult(:value="$v.bank_acc_holder" :name="$t('ui.bank_acc_holder')")
                .col-sm-12.col-md-12.col-lg-12.col-xl-12
                  b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
                .col-sm-12.col-md-6.col-lg-6.col-xl-6
                  SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.reset')" isModal=false type="button"  @click="clear()")
                  SubmitButton.ml-2(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=false type="button" @click="submit" :disabled="loading")
                  SubmitButton(:loading="loading" style="float:right;" variant="danger" icon="fa fa-times" :text="$t('ui.remove')" isModal=false type="button" @click="remove()" :disabled="loading")
</template>

<script>
import config from "@/config"
import {
  required,
  minValue,
  maxValue,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  alphaNum,
  helpers,
  requiredIf
} from "vuelidate/lib/validators"
import SubmitButton from "@/library/SubmitButton"
import ValidateResult from "@/library/ValidateResult"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  data() {
    return {
      bank_name: "",
      bank_acc_no: "",
      bank_acc_holder: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
    };
  },
  validations: {
    bank_name: {
      required : requiredIf(function (value) {
        if (this.bank_acc_no.length != 0 || this.bank_acc_holder.length != 0)
          return true;
        else
          return false;
      }),
      maxLength: maxLength(50)
    },
    bank_acc_no: {
      required : requiredIf(function (value) {
        if (this.bank_name.length != 0 || this.bank_acc_holder.length != 0)
          return true;
        else
          return false;
      }),
      maxLength: maxLength(50)
    },
    bank_acc_holder: {
      required : requiredIf(function (value) {
        if (this.bank_acc_no.length != 0 || this.bank_name.length != 0)
          return true;
        else
          return false;
      }),
      maxLength: maxLength(100)
    },
  },
  computed: {
  },
  mounted: function() {
    this.search()
  },
  methods: {
    reset: function() {
      this.$v.$reset()
      this.submission.success = true
      this.submission.status = ""
    },
    clear: function() {
      this.bank_name = ""
      this.bank_acc_no = ""
      this.bank_acc_holder = ""

      this.$nextTick(() => {
        this.reset()
      });
    },
    search: function() {
      this.loading = true
      this.$store
        .dispatch("user/getBankAccount", {})
        .then(response => {
          this.loading = false
          if (response.data.length > 0) {
            this.bank_name = response.data[0].bank_name == null ? '' : response.data[0].bank_name;
            this.bank_acc_no = response.data[0].bank_acc_no == null ? '' : response.data[0].bank_acc_no;
            this.bank_acc_holder = response.data[0].bank_acc_holder == null ? '' : response.data[0].bank_acc_holder;
          }
        })
        .catch(response => {
          // console.log("child1", response)
          this.loading = false
        });
    },
    remove: function() {
      this.reset();
      this.bank_name = ""
      this.bank_acc_no = ""
      this.bank_acc_holder = ""
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.loading = true;
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_bank_account_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateBankAccount();
          } else if (
            // Read more about handling dismissals
            result.dismiss === "cancel"
          ) {
            this.loading = false;
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_bank_account_cancel"),
              type: "error"
            }).then(isConfirm => {
              if (isConfirm) {
                this.search();
              }
            });
          }
        });
      }
    },
    submit: function() {
      this.reset();
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.loading = true;
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_bank_account_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateBankAccount();
          } else if (
            // Read more about handling dismissals
            result.dismiss === "cancel"
          ) {
            this.loading = false;
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_bank_account_cancel"),
              type: "error"
            }).then(isConfirm => {
              if (isConfirm) {
                this.search();
              }
            });
          }
        });
      }
    },
    updateBankAccount: function() {
      let bank_name = this.bank_name
      let bank_acc_no = this.bank_acc_no
      let bank_acc_holder = this.bank_acc_holder

      this.$store
        .dispatch("user/updateBankAccount", {
          bank_name,
          bank_acc_no,
          bank_acc_holder
        })
        .then(response => {
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_bank_account_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.search();
              }
            });
          }
        })
        .catch(response => {
          this.loading = false;
          if((typeof response.errorTag) != 'object') {
            this.submission.success = response.success;
            this.submission.status = this.$t("message." + response.errorTag);
          }
        });
    },
  }
}
</script>